<template>
    <div class="loading-state">
        <b-spinner label="Loading..." variant="dark" />
    </div>
</template>

<script>
export default {
    name: 'BaseLoadingState'
};
</script>

<style lang="scss" scoped>
.loading-state {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
}
</style>